<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Sweetalert 2</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://sweetalert2.github.io/" target="_black">Sweetalert</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Colors</h5>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <p>A basic message</p>
                  <button class="btn btn-primary" aria-label="Try me! Example: A basic message"
                    onclick="executeExample('basicMessage')">Try me!</button>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html"></code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
